module.exports = __webpack_public_path__ + "media/images/front/banner_minpre_250408-a3d4bc058ec2a8a9f8a50d0290113234.jpg";